<template>
  <surg-add v-if="surgery" :editSurgery="surgery" />
</template>

<script>
import SurgAdd from "./SurgAdd.vue";

export default {
  components: { SurgAdd },
  name: "SurgEdit",
  data() {
    return {
      surgery: null,
      documents: null
    };
  },
  async mounted() {
    const res = await this.$API.getSurgeryInfo(this.$route.params.id);
    if (res && res.status == "OK") {
      let surg = res.message.surgery;
      // this.documents = res.message.documents;

      let editGender;
      if (
        res.message.patient.gender === "male" ||
        res.message.patient.gender === "זכר"
      ) {
        editGender = "male";
      } else if (
        res.message.patient.gender === "female" ||
        res.message.patient.gender === "נקבה"
      ) {
        editGender = "female";
      } else {
        editGender = "";
      }
      // documents
      const resDoc = await this.$API.getSurgeryDocuments(this.$route.params.id);
      if (resDoc && resDoc.data && resDoc.data.data) {
        this.documents = resDoc.data.data.map(d => {
          return {
            id: d.id,
            name: d.file.file_name,
            path:
              "https://md-booking.hmc.co.il/ex-doctor/external" +
              d.file.full_path,
            type: d.type
          };
        });
      } else {
        this.documents = [];
      }

      // 1 - current_surgery
      let selected_surgery = [];
      if (surg.procedure) {
        const current_surgery_arr = JSON.parse(surg.procedure);
        if (current_surgery_arr.current) {
          current_surgery_arr.current.map(s => {
            selected_surgery.push({
              category: s.surgery_category ?? "",
              code_name_clinical: s.procedure_name
                ? s.procedure_name
                : s.procedure,
              code_name_hospital: s.surgery_name,
              duration: s.surgery_duration,
              side: s.side ?? ""
            });
          });
        }
      }
      //
      let current_diagnosis = [];
      let past_diagnosis = [];
      if (surg.diagnosis) {
        const diagnosis = JSON.parse(surg.diagnosis);
        // 3 - current_diagnosis
        if (diagnosis.current && diagnosis.current.length) {
          diagnosis.current.map(diagnosis => {
            current_diagnosis.push({
              side: diagnosis.side ?? "",
              code: diagnosis.diagnosis_number,
              name: diagnosis.diagnosis_name,
              notes: diagnosis.notice
            });
          });
        }
        // 4 - past_diagnosis
        if (diagnosis.past && diagnosis.past.length) {
          diagnosis.past.map(diagnosis => {
            past_diagnosis.push({
              side: diagnosis.side ?? "",
              diagnosis_number: diagnosis.diagnosis_number,
              diagnosis_name: diagnosis.diagnosis_name,
              notice: diagnosis.notice
            });
          });
        }
      }

      //
      let medication_sensitivity = [];
      let material_sensitivity = [];
      const sensitivity = JSON.parse(res.message.patient.sensitivity);
      if (sensitivity) {
        // 6 - medication_sensitivity
        if (sensitivity.medication && sensitivity.medication.length) {
          sensitivity.medication.map(sens => {
            medication_sensitivity.push({
              reaction: sens.response,
              severity: sens.severity,
              name: sens.medication,
              notes: sens.notice
            });
          });
        }
        // 7 - material_sensitivity
        if (sensitivity.material && sensitivity.material.length) {
          sensitivity.material.map(material => {
            material_sensitivity.push({
              reaction: material.response,
              severity: material.severity,
              name: material.material_name,
              notes: material.notice
            });
          });
        }
      }
      // 8 - insurance_surgery
      let insurance_surgery = [];
      if (surg.procedure) {
        const insurance_info_arr = JSON.parse(surg.procedure);
        if (
          insurance_info_arr.insurance &&
          insurance_info_arr.insurance.length
        ) {
          insurance_info_arr.insurance.map(insurance => {
            insurance_surgery.push({
              insurance_type: insurance.insurance,
              category: insurance.surgery_category,
              code: insurance.surgery_name,
              notes: insurance.notice
            });
          });
        }
      }
      let birth_date;
      if (res.message.patient.birthDate) {
        birth_date = this.$moment(
          res.message.patient.birthDate,
          "YYYY-MM-DD"
        ).format("DD/MM/YYYY");
      }
      this.surgery = {
        id_num: res.message.patient.passport,
        first_name: res.message.patient.firstName,
        last_name: res.message.patient.lastName,
        birth_date: birth_date,
        parent_name: res.message.patient.apotropos || "",
        phone: res.message.patient.phone || "",
        phone2: res.message.patient.phone2 || "",
        lang: res.message.patient.language || "",
        gender: editGender,
        selected_surgery: selected_surgery,
        treatment_history: surg.indication,
        current_diagnosis: current_diagnosis,
        past_diagnosis: past_diagnosis,
        checkbox_past_diagnosis: surg.checkbox_past_diagnosis ? true : false,
        background_diagnosis: "",
        phisycal_check: surg.physicalExam,
        no_drug_sens: res.message.patient.checkbox_medication_sensitivity
          ? true
          : false,
        no_material_sens: res.message.patient.checkbox_material_sensitivity
          ? true
          : false,
        medication_sensitivity: medication_sensitivity,
        material_sensitivity: material_sensitivity,
        insurance_surgery: insurance_surgery,
        assistant: surg.assistant_status,
        assistant_name: surg.assistant_name,
        hospitalization: surg.hospitalization,
        anesthesia: surg.anesthesia,
        xray_type: surg.xray_type,
        select_frozen_cut: surg.frozen_cut,
        requests: {
          monitoring_request: surg.monitoring_request == "כן" ? true : false,
          blood: surg.blood == "כן" ? true : false,
          icu: surg.icu == "כן" ? true : false,
          tee_request: surg.tee_request == "כן" ? true : false,
          navigation_request: surg.navigation_request == "כן" ? true : false
        },
        doctor_fee: surg.doctor_fee,
        insurance_type: surg.insurance_name,
        resources: surg.resources,
        notes: surg.notes,
        files: this.documents
      };
      if (res.message.patient.passport_type) {
        this.surgery.passport_type = res.message.patient.passport_type;
      }
    }
  }
};
</script>
